import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { actionCreators } from "../redux/productSalesSagas";
import ToggleableButton from "../../../../../components/toggleableButton/toggleableButton";

const IncludeReturns = () => {
  const dispatch = useDispatch();
  const includeReturns = useSelector((state) => state.productSales.selectedFilters.include_returns);

  return (
    <ToggleableButton
      isActive={includeReturns}
      isRadio
      title="product-sales-toggle-revenue"
      onClick={(data) => dispatch(actionCreators.updateShowNetRevenue(data))}
    />
  );
};

export default IncludeReturns;
